import {
    QUERY_GET_SUPPLIER_SERVICES_BY_SUPPLIER,
    QUERY_POST_CREATE_SUPPLIER_SERVICE,
    QUERY_DELETE_SUPPLIER_SERVICE
} from '../../fetch/constantQueries';
import { baseThunk } from '../../fetch/basicThunk';

export const getSupplierServices = baseThunk('supplierServices/getBySupplier', QUERY_GET_SUPPLIER_SERVICES_BY_SUPPLIER, 'GET');
export const createSupplierService = baseThunk('supplierServices/create', QUERY_POST_CREATE_SUPPLIER_SERVICE, 'POST');
export const deleteSupplierService = baseThunk('supplierServices/delete', QUERY_DELETE_SUPPLIER_SERVICE, 'DELETE');
